import { translate, load } from './LegacyJavascriptTranslationService';
const LegacyJavascriptTranslationService = {
  load,
  translate,
};
export default LegacyJavascriptTranslationService;
